import { useTranslation } from 'react-i18next'

import { EMPTY_STRING } from '../../../constants/common'
import Button from '../../Button'
import { FloatingTooltip } from '../../Floating'
import { InputField } from '../../Input'
import { List } from '../../List'
import { ListItem } from '../../ListItem'
import Text from '../../Text'

import { TEMPLATES_LIST_HEIGHT } from './EmailGoogleTemplatesList.constants'

import * as styles from './EmailGoogleTemplatesList.module.css'

import RefreshIcon from '../../../icons/refresh.svg'
import SearchIcon from '../../../icons/search.svg'

function EmailGoogleTemplatesList({
  search,
  selectedTemplate,
  templates,
  onChangeSearch,
  onRefreshTemplates,
  onSelectTemplate,
}) {
  const { t } = useTranslation()

  function handleChangeSearch({ target: { value } }) {
    onChangeSearch(value)
  }

  function handleClearSearch() {
    onChangeSearch(EMPTY_STRING)
  }

  function getHandleClick(template) {
    return () => {
      onSelectTemplate(template)
    }
  }

  return (
    <List
      className={styles.list}
      itemsWrapperClassName={styles.itemsWrapper}
      maxHeight={TEMPLATES_LIST_HEIGHT}
      prependItem={
        <div className={styles.refreshItem}>
          <Text isSecondary>{t('Email.GoogleTemplateAllTemplatesKey')}</Text>
          <Button.Text
            beforeIconProps={{ Icon: RefreshIcon }}
            text={t('Email.GoogleTemplateRefreshKey')}
            onClick={onRefreshTemplates}
          />
        </div>
      }
      searchElement={
        <InputField
          afterIconProps={{ Icon: SearchIcon }}
          placeholder={t('Email.GoogleTemplateSearchPlaceholderKey')}
          value={search}
          wrapperClassName={styles.searchInput}
          onChange={handleChangeSearch}
          onClear={handleClearSearch}
        />
      }
    >
      {templates.length === 0 ? (
        <Text isSecondary className={styles.noData}>
          {t('Email.GoogleTemplateNoDataKey')}
        </Text>
      ) : (
        templates.map(template => (
          <ListItem
            isActive={template.id === selectedTemplate?.id}
            key={template.id}
            onClick={getHandleClick(template)}
          >
            <FloatingTooltip content={template.name}>
              <Text>{template.name}</Text>
            </FloatingTooltip>
          </ListItem>
        ))
      )}
    </List>
  )
}

export default EmailGoogleTemplatesList
